import LoaderComponent from '../../Loader';
import SubscriptionSummary from './SubscriptionSummary';

export default function SubscriptionDetails({
  loading,
  summaryData,
  getData,
  userId,
  invoices,
  customer,
  charges,
  disputes
}) {
  return <>
  {
    loading ? <LoaderComponent /> :
      <SubscriptionSummary
        subscriptions={summaryData.subscriptions}
        stripeCards={summaryData?.stripeCards}
        userId={userId}
        loading={loading}
        refreshList={getData}
        invoices={invoices}
        customer={customer}
        charges={charges}
        disputes={disputes}
      />
  }
</>
}
